import { defineMachine } from "../state-machine.js";
/** Airwallex payment intent, one per schedule item; every move is driven by a confirmed webhook. */
export const paymentIntent = defineMachine({
    name: "payment-intent",
    states: [
        "requires_payment",
        "processing",
        "held",
        "released",
        "partially_refunded",
        "refunded",
        "failed",
        "cancelled",
    ],
    events: [
        "processing_started",
        "hold_confirmed",
        "failed",
        "cancelled",
        "release_confirmed",
        "partial_refund_confirmed",
        "full_refund_confirmed",
    ],
    initial: "requires_payment",
    transitions: {
        requires_payment: {
            processing_started: "processing",
            hold_confirmed: "held",
            failed: "failed",
            cancelled: "cancelled",
        },
        processing: { hold_confirmed: "held", failed: "failed", cancelled: "cancelled" },
        held: {
            release_confirmed: "released",
            partial_refund_confirmed: "partially_refunded",
            full_refund_confirmed: "refunded",
        },
        partially_refunded: {
            release_confirmed: "released",
            partial_refund_confirmed: "partially_refunded",
            full_refund_confirmed: "refunded",
        },
        released: {},
        refunded: {},
        failed: {},
        cancelled: {},
    },
});
//# sourceMappingURL=intent.machine.js.map